import React from 'react';
import { useHistory } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Icon from '@material-ui/core/Icon';
import { useTranslation } from 'react-i18next';
import * as PConstants from '../../common/constants';
import styled from 'styled-components';
export const MenuItem = (props) => {
    const { title, icon, path, type, onClose, selected, setSelectedMenuPath } = props;
    const history = useHistory();
    const { t } = useTranslation();
    const onClickMenu = () => {
        props.onClickMenu(type);
        if (path) {
            setSelectedMenuPath(path);
            onClose();
            history.push(`${path}`);
        }
    };
    return (React.createElement(SListContainer, null,
        React.createElement(ListItem, { button: true, key: title, onClick: onClickMenu, selected: selected },
            React.createElement(ListItemIcon, null,
                React.createElement(Icon, null, icon)),
            React.createElement(ListItemText, { primary: t(title) }))));
};
const SListContainer = styled.div `
  .Mui-selected {
    background-color: ${PConstants.COLOR.ORANGE700} !important;
    color: #fff;
    border-top-right-radius: 40px;
    border-bottom-right-radius: 40px;
    .MuiListItemIcon-root {
      color: #fff;
    }
    &:hover {
      background-color: ${PConstants.COLOR.ORANGE700};
    }
  }
`;
